import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=5dae9e64&scoped=true&"
import script from "./Accounts.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Accounts.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae9e64",
  null
  
)

export default component.exports